"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCouponSavingsAmount = exports.getCouponOffAmount = exports.COUPON_CURRENCY_SYMBOL = void 0;
const COUPON_CURRENCY_SYMBOL = exports.COUPON_CURRENCY_SYMBOL = '₹';
const trim = value => {
  const num = Number(value);
  if (!Number.isFinite(num) || num === 0) return null;
  return String(Number(num.toFixed(2)));
};
const getCouponSavingsAmount = value => {
  const amount = trim(value);
  return amount ? "".concat(COUPON_CURRENCY_SYMBOL).concat(amount) : null;
};
exports.getCouponSavingsAmount = getCouponSavingsAmount;
const getCouponOffAmount = function () {
  let coupon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const value = trim(coupon.offValue);
  if (!value) return null;
  return coupon.offUnit === 'percent' ? "".concat(value, "%") : "".concat(COUPON_CURRENCY_SYMBOL).concat(value);
};
exports.getCouponOffAmount = getCouponOffAmount;